import {
    computed,
    Directive,
    effect,
    inject,
    input,
    TemplateRef,
    ViewContainerRef
} from '@angular/core';
import { AppUserService } from '@services';
import { PlanType } from 'moddy/common';

@Directive({
    selector: '[forPlan]'
})
export class ForPlanDirective {
    public readonly plan = input.required<PlanType | PlanType[]>({ alias: 'forPlan' });
    public readonly shouldRender = input.required<boolean>({ alias: 'forPlanShouldRender' });

    private readonly planAsArray = computed<PlanType[]>(() => {
        const plan = this.plan();

        return Array.isArray(plan) ? plan : [plan];
    });

    private readonly userService = inject(AppUserService);
    private readonly viewContainerRef = inject(ViewContainerRef);
    private readonly templateRef = inject(TemplateRef);

    constructor() {
        effect(() => {
            const userPlan = this.userService.data()?.subscriptionData.planType;

            this.viewContainerRef.clear();

            if (!userPlan) {
                return;
            }

            if (
                (this.planAsArray().includes(userPlan) && this.shouldRender()) ||
                (!this.shouldRender() && !this.planAsArray().includes(userPlan))
            ) {
                this.viewContainerRef.createEmbeddedView(this.templateRef);
            }
        });
    }
}
